import { ScreenSize, ViewportSize } from "../types";

export const getSizeValue = (size: string, defaultValue: string): string => {
	switch (size) {
		case "XS":
			return "60px";
		case "S":
			return "80px";
		case "M":
			return "120px";
		case "L":
			return "160px";
		case "XL":
			return "200px";
		default:
			return defaultValue;
	}
};

export const getSizeClass = (size: string): string => {
	switch (size) {
		case "XS":
			return "1";
		case "S":
			return "2";
		case "M":
			return "3";
		case "L":
			return "4";
		case "XL":
			return "5";
		default:
			return "3";
	}
};

// Helper function to determine if a component should be visible in the current viewport
export const shouldComponentShow = (
	hideInSizes: ScreenSize[] | undefined,
	showOnlyInSizes: ScreenSize[] | undefined,
	viewportSize: ViewportSize
): boolean => {
	if (hideInSizes) {
		if (
			(viewportSize === "mobile" && hideInSizes.includes("XS")) ||
			(viewportSize === "tablet" && hideInSizes.includes("M")) ||
			(viewportSize === "desktop" && hideInSizes.includes("XL"))
		) {
			return false;
		}
	}

	if (showOnlyInSizes) {
		if (
			(viewportSize === "mobile" && !showOnlyInSizes.includes("XS")) ||
			(viewportSize === "tablet" && !showOnlyInSizes.includes("M")) ||
			(viewportSize === "desktop" && !showOnlyInSizes.includes("XL"))
		) {
			return false;
		}
	}

	return true;
};

// Parse CSS text to CSS object
export const parseCssText = (cssText: string): Record<string, string> => {
	try {
		const cssLines = cssText.split("\n");
		const stylesObj: Record<string, string> = {};

		cssLines.forEach((line) => {
			const [key, value] = line.split(":").map((part) => part.trim());
			if (key && value) {
				stylesObj[key] = value.replace(/;$/, "");
			}
		});

		return stylesObj;
	} catch (error) {
		console.error("Error parsing CSS", error);
		return {};
	}
};

// Convert CSS object to CSS text
export const cssObjectToText = (cssObject: Record<string, string>): string => {
	return Object.entries(cssObject)
		.map(([key, value]) => `${key}: ${value};`)
		.join("\n");
};
